<template>
  <div>
    <section>
      <b-container fluid class="d-flex justify-content-center banner-faq">
        <b-row align-v="center">
          <b-col>
            <h1 class="banner-text">Je ne veux plus recevoir d'emails</h1>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="sec-back">
      <div style="display: flex; flex-direction: column;">
        <div class="form-group">
          <label class="form-label" for="email">Adresse email</label>
          <input type="email" class="form-input" id="email" aria-describedby="emailHelp"
            placeholder="Entrez votre adresse email" v-model="email" />
          <small id="emailHelp" class="form-text text-muted">
            Nous ne partagerons jamais votre adresse email avec quelqu'un d'autre.
          </small>
        </div>

        <div class="form-group">
          <label class="form-label" for="reason">Raison</label>
          <select class="form-input" id="reason" v-model="reason">
            <option>Je reçois trop d'emails</option>
            <option>Je ne suis plus intéressé(e)</option>
            <option>Autre</option>
          </select>
        </div>

        <button type="submit" class="btn btn-primary" @click.prevent="unsubscribe">
          Se désinscrire
        </button>

        <!-- feedback messages -->
        <div v-if="successMessage" class="alert alert-success mt-3">
          {{ successMessage }}
        </div>
        <div v-if="errorMessage" class="alert alert-danger mt-3">
          {{ errorMessage }}
        </div>
      </div>
    </section>

    <div v-if="showModal" id="confirmDeleteModal" class="custom-modal">
      <div class="custom-modal-overlay" @click="showModal = false"></div>

      <div class="custom-modal-content">
        <button class="close-button" @click="showModal = false">&times;</button>
        <h2>Supprimer mon compte</h2>
        <p>
          Voulez-vous vraiment supprimer votre compte ?
        </p>
        <p>
          <strong>Toutes vos données seront perdues.</strong> Cela inclut :
        </p>
        <ul>
          <li>Votre historique de menu</li>
          <li>Vos favoris</li>
          <li>Vos préférences</li>
          <li>Les membres de votre foyer</li>
        </ul>
        <p>Vous pouvez toujours recréer un nouveau compte ultérieurement.</p>

        <div class="custom-modal-actions">
          <button class="btn btn-secondary" @click="showModal = false">Annuler</button>
          <button class="btn btn-danger" @click="confirmDelete">Supprimer mon compte</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      reason: "trop",
      loading: false,
      successMessage: "",
      errorMessage: "",
      showModal: false, // modal affichée ou non
    };
  },
  methods: {
    async unsubscribe() {
      this.successMessage = "";
      this.errorMessage = "";

      if (!this.email || !/\S+@\S+\.\S+/.test(this.email)) {
        this.errorMessage = "Veuillez entrer une adresse email valide.";
        return;
      }

      this.loading = true;

      try {
        // Étape 1 : vérifier si l'utilisateur existe
        const checkResponse = await fetch(
          `${process.env.VUE_APP_BASE_URL}/api/check_user/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: this.email })
          }
        );

        const data = await checkResponse.json();

        if (checkResponse.status === 404) {
          this.errorMessage = "Aucun compte n'est associé à cet email.";
        } else if (checkResponse.ok) {
          // ✅ Email existe, on affiche la modale
          this.showModal = true;
        } else {
          this.errorMessage = data.message || "Erreur de vérification.";
        }
      } catch (err) {
        this.errorMessage = "Une erreur est survenue. Veuillez réessayer.";
      } finally {
        this.loading = false;
      }
    },

    async confirmDelete() {
      this.loading = true;
      this.errorMessage = "";
      this.successMessage = "";

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/api/public/delete_account/`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.email })  // on passe l'email saisi
          }
        );

        if (response.status === 204) {
          this.successMessage = "Votre compte a été supprimé avec succès.";
          this.showModal = false;
          this.email = "";
        } else {
          const data = await response.json().catch(() => ({}));
          this.errorMessage = data.message || "Erreur lors de la suppression du compte.";
        }
      } catch (err) {
        this.errorMessage = "Une erreur est survenue. Veuillez réessayer.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>


<style scoped>
.banner-faq {
  background-clip: border-box;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/healthy-scaled.jpg");
  /*linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), top 150px center fixed no-repeat; */
  margin: 50px 0;

  width: 100%;
  height: 700px;
  background-attachment: fixed;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.banner-text {
  font-family: "Amanise";
  font-size: clamp(36px, 4vw + 29px, 84px);
  font-weight: 400;
  color: white;
}

.faq-container {
  background-color: #edf4d9;
  padding: 20px;
  border-radius: 15px;
}

.sec-back {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}

/* --- MODAL PERSONNALISÉE --- */
.custom-modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Overlay sombre semi-transparent */
.custom-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}

/* Contenu de la modale */
.custom-modal-content {
  position: relative;
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  z-index: 10000;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
  animation: fadeInUp 0.25s ease-out;
}

/* Bouton de fermeture (X) */
.close-button {
  position: absolute;
  top: 10px;
  right: 15px;
  border: none;
  background: none;
  font-size: 1.8rem;
  color: #888;
  cursor: pointer;
  transition: color 0.2s ease;
}

.close-button:hover {
  color: #d9534f;
}

/* Zone des boutons d'action */
.custom-modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
  gap: 10px;
}

/* Animation d'apparition */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>